<kt-portlet [ngClass]="'kt-portlet--ngviewer'">
    <kt-portlet-header [title]="'Gráfico de Frequência  (' + _description +')'">
      <ng-container ktPortletTools>
      <!-- 🔽 Botão Exportar CSV -->
  <button mat-icon-button matTooltip="Exportar Excel" (click)="exportToExcel()">
    <i class="la la-download more-size"></i>
  </button>
        <mat-button-toggle-group #group="matButtonToggleGroup" [(value)]="_sort" (change)="changeSort($event)">
          <mat-button-toggle value="asc" aria-label="Text align left">
            <i class="la la-sort-amount-asc more-size"></i>
          </mat-button-toggle>
          <mat-button-toggle value="desc" aria-label="Text align center">
            <i class="la la-sort-amount-desc more-size"></i>
          </mat-button-toggle>
  
        </mat-button-toggle-group>

      </ng-container>
    </kt-portlet-header>
  
    <kt-portlet-body>
  
      <div *ngIf="_lotteryDrawn!=null && !_isControl">
  
        <!-- <form class="example-form">  -->
  
        <div class="row">
  
     
          <div *ngIf="_rangeOptions.length > 1" class="col-md-3">
  
            <mat-form-field class="full-width">
  
              <intelli-selector placeholder="Sorteio" [options]="_rangeOptions" [formControl]="_rangeOptionsControl">
              </intelli-selector> 
            </mat-form-field>
  
          </div>
  
          <div class="col-md-3">
  
            <mat-form-field class="lottery-draw-label">
              <input type="text" placeholder="{{_startLotteryDrawLabel}}" aria-label="Number" matInput
                [formControl]="_startLotteryDrawControl" [matAutocomplete]="autoStart">
              <mat-autocomplete #autoStart="matAutocomplete">
                <mat-option *ngFor="let option of _startfilteredOptions | async" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
  
          </div>
          <div class="col-md-3">
            <mat-form-field class="lottery-draw-label">
              <input type="text" placeholder="{{_endLotteryDrawLabel}}" aria-label="Number" matInput
                [formControl]="_endLotteryDrawControl" [matAutocomplete]="autoEnd">
              <mat-autocomplete #autoEnd="matAutocomplete">
                <mat-option *ngFor="let option of _endfilteredOptions | async" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
  
          </div>
  
  
  
  
          <div class="col-md-3">
            <!--  -->
            <button mat-raised-button (click)="onRefreshClick()" [disabled]="!_showGraph"
              color="accent">{{_updateChartLabel}}</button>
          </div>
        </div>
  
  
  
  
  
  
        <!-- </form>  -->
  
      </div>
      <div>
  
        <div class="row" *ngIf="_isControl">
  
  
          <div class="col-md-12">
            <mat-form-field class="full-width">
  
              <intelli-selector placeholder="Clique para alterar a opção de estatística" [options]="_groupLens"
                [value]="1" (change)="changeGroupLen($event)"> </intelli-selector>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div *ngIf="!_showGraph">
  
        <kt-soft-progress-bar-green prefix="Gerando estatística  " [percentValue]="this._progress">
        </kt-soft-progress-bar-green>
      </div>
  
      <div id="chart-frequency-div" [style.height]='_graphHeight'></div>
  
  

    </kt-portlet-body>
  </kt-portlet>